import { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

const PAGE_SIZE = 5;

export default function News() {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const items = newsList.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6">
      <nav className="mb-4 flex items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">影视资讯</span>
      </nav>

      <div className="mb-6 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">影视资讯</h1>
        <p className="mt-2 max-w-2xl text-sm text-foreground-600">
          汇集最新影视新闻、行业动态与作品观察，按时间倒序为你呈现影视圈正在发生的事。
        </p>
      </div>

      {newsList.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-400">
            <i className="ri-newspaper-line text-3xl"></i>
          </span>
          <h2 className="mt-4 text-lg font-bold text-foreground-800">暂时还没有资讯</h2>
          <p className="mt-1 text-sm text-foreground-500">请稍后再来看看，或先浏览影视资源</p>
          <Link
            to="/category/movie"
            className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            浏览电影
          </Link>
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4">
            {items.map((news) => (
              <article key={news.id} className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200">
                <Link to={`/news/${news.id}`} className="group block">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-secondary-900">
                      <i className="ri-price-tag-3-line"></i> {news.source}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i> {news.date}
                    </span>
                  </div>
                  <h2 className="mt-3 text-lg font-bold text-foreground-950 group-hover:text-primary-600 md:text-xl">
                    {news.title}
                  </h2>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{news.summary}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </article>
            ))}
          </div>

          <div className="mt-8 flex items-center justify-center gap-2">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={current === 1}
              className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-600 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-300 hover:enabled:text-primary-600"
            >
              <i className="ri-arrow-left-s-line"></i> 上一页
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                onClick={() => setPage(p)}
                className={`h-9 w-9 rounded-md text-sm transition-colors ${
                  p === current
                    ? 'bg-primary-500 font-medium text-background-50'
                    : 'border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {p}
              </button>
            ))}
            <button
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={current === totalPages}
              className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-600 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-300 hover:enabled:text-primary-600"
            >
              下一页 <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </>
      )}
    </div>
  );
}